import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button, Stack, Typography } from '@mui/material'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import mailIcon from '@/assets/images/verifyMail.png'
import { env } from '@/utils/constants'

const VerifyEmail = () => {
  const { logout, isAuthenticated, getIdTokenClaims } = useAuth0()
  const [sId, setSId] = useState<string | null>(null)
  const [email, setEmail] = useState<string>('')

  const resendEmailAPI = async (userId: string) => {
    try {
      const response = await axios.get(
        `${env.BASE_URL}/users/auth/email-verification/?user_id=${userId}`,
        {
          headers: {
            platform: 'web',
            session: '',
          },
        },
      )
      return response.data
    } catch (error) {
      console.error('Verification resend error:', error)
      throw error
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      getIdTokenClaims().then((response) => {
        if (response) {
          localStorage.setItem('auth', response.__raw)
          setSId(response.sub)
          setEmail(response.email)
        }
      })
    }
  }, [isAuthenticated, getIdTokenClaims])

  const resendEmail = () => {
    resendEmailAPI(sId)
      .then(() => toast.success('Verification email sent!'))
      .catch(() => toast.error('Something went wrong! Please try again later.'))
  }

  const logoutWithRedirect = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })
  }

  return (
    <Box
      sx={{
        backgroundColor: '#000',
        height: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        color: '#fff',
        px: 2,
      }}
    >
      <Box
        component="img"
        src={mailIcon}
        alt="Verify Email"
        sx={{ width: '120px', mb: 4 }}
      />

      <Typography
        variant="h5"
        align="center"
        sx={{ mb: 2, fontSize: '32px', fontWeight: 400 }}
      >
        Please verify your email {email} <br /> to proceed further.
      </Typography>

      <Stack direction="row" spacing={2} mt={4}>
        <Button
          variant="outlined"
          onClick={logoutWithRedirect}
          sx={{
            color: '#90CAF9',
            borderColor: '#90CAF9',
            fontWeight: 500,
            fontSize: '14px',
            px: 3,
            '&:hover': {
              borderColor: '#90CAF9',
            },
          }}
        >
          LOGOUT
        </Button>

        <Button
          variant="contained"
          onClick={resendEmail}
          sx={{
            backgroundColor: '#90CAF9',
            color: '#000',
            fontWeight: 500,
            fontSize: '14px',
            px: 3,
            '&:hover': {
              backgroundColor: '#90CAF9',
            },
          }}
        >
          RESEND
        </Button>
      </Stack>
    </Box>
  )
}

export default VerifyEmail
